import FeatureFlag, {
  FeatureFlagCanada,
} from "@repo/kikoff-models/FeatureFlag";
import canadaRpc from "@repo/protobuf/api/canadaRpc";
import UFunction from "@repo/utils/UFunction";
import FeatureStore from "@repo/utils-solid/FeatureStore";

const initialState = {
  byName: {} as { [Name in FeatureFlag.Name]?: boolean },
};

export const { Provider, useFeatureFlags, Context } = FeatureStore.init(
  "FeatureFlags",
  initialState,
  ([store, setStore], { attachAction, withLogger }) => {
    const accessors = {
      enabled: attachAction(
        (name: FeatureFlag.Name) => store.byName[name],
        (name) => actions.fetch(name)
      ),
    };

    const us = {
      actions: {
        fetch: UFunction.todo,
      },
    };

    const canada = {
      actions: {
        fetch(...names: FeatureFlag.Name[]) {
          return canadaRpc.FeatureFlags.show({
            names: names.map(FeatureFlagCanada.Name.denormalize),
          }).then((data) => {
            setStore(
              "byName",
              Object.fromEntries(
                data.features.map(({ name, pass }) => [
                  FeatureFlagCanada.Name.normalize(name),
                  pass,
                ])
              )
            );
          });
        },
      },
    };

    const actions = withLogger(
      "actions",
      import.meta.env.API_ADAPTER === "canada" ? canada.actions : us.actions
    );

    return { accessors, actions };
  }
);
